import { useState } from "react";
import { toast } from "sonner";
import { BellPlus, Link2, MailCheck } from "lucide-react";
import { api, formatApiError, PUBLIC_ORIGIN } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";

export const profileShareUrl = (handle) => `${PUBLIC_ORIGIN}/api/p/${handle}`;

export const CopyProfileLink = ({ handle, testid = "profile-copy-link" }) => {
  const { t } = useI18n();
  const copy = async () => {
    try { await navigator.clipboard.writeText(profileShareUrl(handle)); toast.success(t("fl.copied")); } catch { toast.message(profileShareUrl(handle)); }
  };
  return (
    <button type="button" onClick={copy} data-testid={testid}
      className="flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 text-sm text-[#3ad7ff] hover:border-white/30 transition-colors">
      <Link2 className="w-4 h-4" />{t("fl.copy")}
    </button>
  );
};

export const FollowBox = ({ handle, name }) => {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");
  const submit = async (e) => {
    e.preventDefault();
    setState("busy");
    try {
      await api.post(`/u/${handle}/follow`, { email });
      setState("sent");
    } catch (err) { toast.error(formatApiError(err)); setState("idle"); }
  };
  if (state === "sent") {
    return (
      <div className="cx-card rounded-2xl p-5 flex items-start gap-3" data-testid="follow-sent">
        <MailCheck className="w-5 h-5 text-[#22e3a1] shrink-0 mt-0.5" />
        <p className="text-sm text-slate-300">{t("fl.sent").replace("{email}", email)}</p>
      </div>
    );
  }
  return (
    <form onSubmit={submit} className="cx-card rounded-2xl p-5" data-testid="follow-box">
      <div className="flex items-center gap-2 text-white font-display"><BellPlus className="w-4 h-4 text-[#ffc94d]" />{t("fl.title").replace("{name}", name)}</div>
      <p className="text-xs text-slate-400 mt-1">{t("fl.desc")}</p>
      <div className="flex flex-col sm:flex-row gap-2 mt-3">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder={t("fl.email_ph")} data-testid="follow-email-input"
          className="flex-1 min-w-0 rounded-full bg-[#070912] border border-white/10 px-4 py-2.5 text-sm text-white outline-none focus:border-[#2f7bff]" />
        <button disabled={state === "busy"} className="cx-btn rounded-full px-5 py-2.5 text-sm font-semibold whitespace-nowrap" data-testid="follow-submit-btn">{t("fl.follow")}</button>
      </div>
      <p className="text-[10px] text-slate-500 mt-2">{t("fl.legal")}</p>
    </form>
  );
};
